import React, { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import AppRoutes from './routes/AppRoutes';
import { fetchAnnouncements, fetchHolidays } from './features/announcements/announcementSlice';
import { PendingRequestsProvider } from './context/PendingRequestsContext';
import { useThemeMode } from './theme/ThemeModeProvider';
import { formatDateTime, isAnnouncementActive } from './utils/notificationUtils';

function App() {
  const dispatch = useDispatch();
  const { announcements } = useSelector((state) => state.announcements);
  const { resolvedMode } = useThemeMode();
  const shownAnnouncementToasts = useRef(new Set());

  const isLoggedIn = Boolean(localStorage.getItem('access_token'));

  useEffect(() => {
    if (isLoggedIn) {
      dispatch(fetchAnnouncements());
      dispatch(fetchHolidays());
    }
  }, [dispatch, isLoggedIn]);

  useEffect(() => {
    if (announcements.length > 0) {
      const now = new Date();
      const activeAnnouncements = announcements.filter((ann) => isAnnouncementActive(ann, now));

      activeAnnouncements.forEach((announcement) => {
        const toastKey = `${announcement.id}-${announcement.updated_at || announcement.created_at || ''}`;
        if (shownAnnouncementToasts.current.has(toastKey)) {
          return;
        }

        shownAnnouncementToasts.current.add(toastKey);

        const activeUntil = announcement.end_date
          ? ` (until ${formatDateTime(announcement.end_date)})`
          : '';

        toast.info(`Announcement: ${announcement.title} - ${announcement.message}${activeUntil}`, {
          autoClose: 4000,
        });
      });
    }
  }, [announcements]);

  return (
    <PendingRequestsProvider>
      <AppRoutes />
      <ToastContainer
        position="top-right"
        autoClose={3000}
        newestOnTop
        closeOnClick
        pauseOnFocusLoss
        draggable
        theme={resolvedMode}
      />
    </PendingRequestsProvider>
  );
}

export default App;

